import eq from "./eq.js";
function assocIndexOf(array, key) {
  for (var length = array.length; length--; )
    if (eq(array[length][0], key))
      return length;
  return -1;
}
export {
  assocIndexOf as default
};
//# sourceMappingURL=_assocIndexOf.js.map
